import { createFarmPlugin } from 'unplugin'

import { unpluginFactory } from './unpluginFactory.ts'

export default createFarmPlugin(unpluginFactory)
